// "Blocked by" surfaced prominently (Scott: "the blocked-by thing is going to
// be really beneficial") — every live X-waits-on-Y pair, with Y's owner.

import type { InitiativeState } from '../../services/roadmapReports';
import { waitingLines } from './roadmapViewUtils';
import styles from './RoadmapV2.module.css';

interface Props {
  initiatives: InitiativeState[];
  /** The whole tracked set, so a filtered-out (e.g. parked) blocker still shows. */
  all?: InitiativeState[];
  onSelect: (key: string) => void;
}

export function BlockedStrip({ initiatives, all = initiatives, onSelect }: Props) {
  const lines = waitingLines(initiatives, all);
  if (lines.length === 0) return null;
  const byKey = new Map(all.map((i) => [i.initiative_key, i]));
  return (
    <section className={`${styles.panel} ${styles.blockedPanel}`} aria-label="Blocked initiatives">
      <div className={styles.panelHead}>
        <h2>Waiting on something: {lines.length} initiative{lines.length === 1 ? '' : 's'}</h2>
        <span className={styles.meta}>held by another initiative or by someone outside · a finished dependency no longer counts</span>
      </div>
      <ul className={styles.blockedList}>
        {lines.map(({ initiative, on }) => (
          <li key={initiative.initiative_key} className={styles.blockedItem}>
            <button type="button" className={styles.linkBtn} onClick={() => onSelect(initiative.initiative_key)}>
              {initiative.title}
            </button>
            <span className={styles.arrow}>is waiting on</span>
            {on.map((o, n) => {
              const blocker = o.key ? byKey.get(o.key) : undefined;
              return (
                <span key={`${o.key ?? 'outside'}:${n}`}>
                  {n > 0 && '; '}
                  {blocker ? (
                    <>
                      <button type="button" className={styles.linkBtn} onClick={() => onSelect(blocker.initiative_key)}>
                        {blocker.title}
                      </button>
                      <span className={styles.meta}>
                        {' '}
                        ({blocker.owner ?? blocker.people[0] ?? 'no owner stated'}
                        {blocker.target_date ? `, target ${blocker.target_date}` : ', no date'})
                      </span>
                    </>
                  ) : (
                    <span>{o.title}{o.title === 'nobody has said what' ? '' : ' (outside the roadmap)'}</span>
                  )}
                </span>
              );
            })}
          </li>
        ))}
      </ul>
    </section>
  );
}
